import React, { useEffect } from 'react'
import Drawer from '@mui/material/Drawer'
import MobileListSideBar from './mobileListSideBar'

interface MobileSidebarProps {
  isSidebarOpen: boolean;
  onCloseSidebar: () => void;
}

// Add this style to the document head
const addNoScrollStyle = () => {
  if (!document.getElementById('no-scroll-style')) {
    const style = document.createElement('style');
    style.id = 'no-scroll-style';
    style.innerHTML = `
      body.no-scroll {
        overflow: hidden !important;
        position: fixed !important;
        width: 100% !important;
        height: 100% !important;
      }
    `;
    document.head.appendChild(style);
  }
};

const MobileSidebar: React.FC<MobileSidebarProps> = ({ isSidebarOpen, onCloseSidebar }) => {
  // Add effect to control body scrolling when sidebar is open
  useEffect(() => {
    addNoScrollStyle();

    if (isSidebarOpen) {
      const scrollY = window.scrollY;
      document.body.classList.add('no-scroll');
      document.body.style.top = `-${scrollY}px`;
    } else {
      if (document.body.classList.contains('no-scroll')) {
        const scrollY = document.body.style.top;
        document.body.classList.remove('no-scroll');
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }

    // Cleanup function
    return () => {
      if (document.body.classList.contains('no-scroll')) {
        const scrollY = document.body.style.top;
        document.body.classList.remove('no-scroll');
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    };
  }, [isSidebarOpen]);

  return (
    <Drawer
      sx={{
        width: '100%',
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: '100%',
          maxWidth: '100%',
          boxSizing: 'border-box',
          backgroundColor: 'primary.white',
          pl: 0,
          pr: 0,
          borderRight: 'none',
          zIndex: 1000, // Lower z-index to stay below the header
          marginTop: '95px', // Add top margin to position below header
          height: 'calc(100vh - 95px)', // Adjust height for mobile
          transition: 'none !important', // Remove animation
          boxShadow: 'none', // Remove shadow
          overflowY: 'auto', // Make sure the sidebar itself is scrollable
          overflowX: 'hidden', // Prevent horizontal scrolling
        },
        display: isSidebarOpen ? 'block' : 'none',
        '& .MuiBackdrop-root': {
          backgroundColor: 'transparent', // Remove darkening effect
        }
      }}
      variant="temporary"
      anchor='left'
      open={isSidebarOpen}
      onClose={onCloseSidebar}
      ModalProps={{ 
        keepMounted: true,
        disableScrollLock: true, // We're manually handling scroll locking
        BackdropProps: {
          invisible: true  // Makes backdrop invisible
        }
      }}
      transitionDuration={0} // Remove transition animation
    >
      <MobileListSideBar />
    </Drawer>
  );
};

export default MobileSidebar;
